import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    toast: true,
    showConfirmButton: false,
    timer: 4000,
    color: "#FDFEFE",
    iconColor: "#FDFEFE",
}

export default {
    install(app) {
        app.use(VueSweetalert2, options);
    }
};